import './DataTableAllColumnsHiddenEmptyState.css';
export var emptyState = '_srhgvd0-3-15-1';